export interface Tag {
  _id: number;
  name: string;
  slug: string;
  status: string;
  usageCount: number;
  createdBy: number;
  createdAt: string;
  updatedAt: string;
}

export interface ProjetInfo {
  _id: number;
  createdAt: string; // or Date, if you're converting it
  updatedAt: string; // or Date, if you're converting it
  status: "active" | "inactive";
  userId: number;
  name: string;
  version: string;
  uuid: string;
  author: {
    firstName: string;
    lastName: string;
  };
  metadata?: {
    [key: string]: any;
  };
  jiraBoard?: string;
  tags?: Tag[];
  // Cached node counts per ontology, returned with every project row (refreshed on the dashboard's Refresh).
  nodeCounts?: ProjectNodeCounts;
  // Per-user star (BREEZEAI-867). Populated by /projects/accessible for the
  // current user; absent on responses from paths that don't join favourites.
  favourite?: boolean;
}

export interface ProjectNodeCounts {
  functional?: number;
  design?: number;
  architecture?: number;
  code?: number;
  repositories?: number;
  linesOfCode?: number;
}

export interface ProjectContextType {
  currentProject: ProjetInfo | null;
  setCurrentProject: React.Dispatch<React.SetStateAction<ProjetInfo | null>>;
}

// Project Member Types
export enum ProjectMemberRole {
  OWNER = "Owner",
  ADMIN = "Admin",
  VIEWER = "Viewer",
}

export interface ProjectMemberUser {
  _id: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface ProjectMember {
  projectId: number;
  userId: number;
  role: string;
  user: ProjectMemberUser;
}

export interface ProjectMemberListProps {
  members: ProjectMember[];
}

export interface ManageAccessModalProps {
  projectName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  // the project when the route has no :id
  projectUuid?: string;
}
